const Office = () => import("@/views/office/Office.vue");
const CreateOffice = () => import("@/views/office/CreateOffice.vue");
const ViewOffice = () => import("@/views/office/ViewOffice.vue");
const EditOffice = () => import("@/views/office/EditOffice.vue");

const TYPE = "ADMIN";

export default {
    path: "office-management",
    meta: { label: "Office Management" },
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: [
      {
        path: "",
        meta: {
          requiresAuth: true,
          type: TYPE,
        },
        component: Office,
      },
      {
        path: "create",
        name: "CreateOffice",
        meta: {
          label: "Create Office",
          requiresAuth: true,
          type: TYPE,
        },
        component: CreateOffice,
      },
      {
        path: "view",
        name: "ViewOffice",
        meta: {
          label: "View Office",
          requiresAuth: true,
          type: TYPE,
        },
        component: ViewOffice,
      },
      {
        path: "edit",
        name: "EditOffice",
        meta: {
          label: "Edit Office",
          requiresAuth: true,
          type: TYPE,
        },
        component: EditOffice,
      },
    ],
}